import { Button } from "@timeedit/ui-components/components/Button/Button";
import { CloseOutlined } from "@timeedit/ui-components/components/Icon/Icons/index";
import Language from "../lib/Language";

type TSidebarDismissButtonProps = {
    useNewUI: boolean;
    onClose: () => void;
};

const SidebarDismissButton = (props: TSidebarDismissButtonProps) => {
    if (props.useNewUI) {
        return (
            <div style={{ position: "absolute", top: "8px", right: "8px" }}>
                <Button
                    size="small"
                    type="text"
                    onClick={props.onClose}
                    icon={<CloseOutlined alt={Language.get("menu_close")} />}
                />
            </div>
        );
    }
    return <div className="dismiss" onClick={props.onClose} />;
};

export default SidebarDismissButton;
